import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Avatar creator functionality disabled
const initialState = {
  avatarCreator: {
    preset: {
      _id: "",
      name: "",
    },
    camera: {
      cameraPosition: "[0,0,0]",
      orbitalTarget: "[0,0,0]",
    },
    avatar: {
      url: "placeholder-avatar-url",
      type: "disabled",
      position: { x: 0, y: 0, z: 0 },
      rotate: { x: 0, y: 0, z: 0 },
      scale: 1,
      speechVoice: "disabled",
      speechText: "Avatar functionality has been disabled",
      welcomeText: "Avatar Disabled",
      background: {
        id: "disabled",
        title: "Avatar Disabled",
        author: {
          name: "System",
          url: "",
        },
        file: "disabled.glb",
        url: "disabled",
      },
      room: {
        position: { x: 0, y: 0, z: 0 },
        scale: 1,
        rotate: { x: 0, y: 0, z: 0 },
      },
    },
  },
};

export const avatarCreatorSlice = createSlice({
  name: "avatarCreator",
  initialState,
  reducers: {
    // All avatar creator actions disabled
    updateAvatarCreator: (state, action: PayloadAction<any>) => {
      // Do nothing - functionality disabled    },
    resetAvatarCreator: (state) => {
      // Do nothing - functionality disabled    },
    updateAvatarSpeechText: (state, action: PayloadAction<string>) => {
      // Do nothing - functionality disabled    },
    updateAvatarBackground: (state, action: PayloadAction<any>) => {
      // Do nothing - functionality disabled    },
    updateAvatarPosition: (state, action: PayloadAction<any>) => {
      // Do nothing - functionality disabled    },
    updateAvatarScale: (state, action: PayloadAction<any>) => {
      // Do nothing - functionality disabled    },
    updateAvatarSpeechVoice: (state, action: PayloadAction<string>) => {
      // Do nothing - functionality disabled    },
    updateAvatarUrl: (state, action: PayloadAction<string>) => {
      // Do nothing - functionality disabled    },
    updateAvatarWelcomeText: (state, action: PayloadAction<string>) => {
      // Do nothing - functionality disabled    },
  },
});

export const {
  updateAvatarCreator,
  resetAvatarCreator,
  updateAvatarSpeechText,
  updateAvatarBackground,
  updateAvatarPosition,
  updateAvatarScale,
  updateAvatarSpeechVoice,
  updateAvatarUrl,
  updateAvatarWelcomeText,
} = avatarCreatorSlice.actions;

export default avatarCreatorSlice.reducer;